module.exports = __webpack_public_path__ + "img/5-1.b927dda1.jpg";